"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLayer = void 0;
var types_1 = require("../types");
var class_validator_1 = require("class-validator");
var BaseLayer = /** @class */ (function () {
    function BaseLayer(type) {
        this.type = type;
        this.opacity = 1;
        this.rotation = 0;
    }
    BaseLayer.prototype.toStrapiObject = function () {
        return {
            type: this.type,
            vertical_alignment: this.verticalAlignment,
            horizontal_alignment: this.horizontalAlignment,
            stretching: this.stretching,
            positionX: this.x,
            positionY: this.y,
            positionZ: this.z,
            rotation: this.rotation,
            width: this.width,
            height: this.height,
            opacity: this.opacity,
            css_style: this.style,
            render_as_html: this.renderAsHtml,
            tag: this.tag,
        };
    };
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Min)(0),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "x", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Min)(0),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "y", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Min)(0),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "z", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "rotation", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Min)(0),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "width", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Min)(0),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "height", void 0);
    __decorate([
        (0, class_validator_1.IsNumber)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.Max)(1),
        __metadata("design:type", Number)
    ], BaseLayer.prototype, "opacity", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        __metadata("design:type", String)
    ], BaseLayer.prototype, "type", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        __metadata("design:type", String)
    ], BaseLayer.prototype, "verticalAlignment", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        __metadata("design:type", String)
    ], BaseLayer.prototype, "horizontalAlignment", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        __metadata("design:type", String)
    ], BaseLayer.prototype, "stretching", void 0);
    __decorate([
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsString)(),
        __metadata("design:type", String)
    ], BaseLayer.prototype, "tag", void 0);
    return BaseLayer;
}());
exports.BaseLayer = BaseLayer;
